// Auth0 configuration for the Siphon SPA.
//
// In production these values are baked at build time via Vite env vars
// (VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID, VITE_AUTH0_AUDIENCE). The
// values below are the Alpha-Level production defaults so the app still
// works in dev without a .env file.

export const AUTH0_DOMAIN   = import.meta.env.VITE_AUTH0_DOMAIN   || 'dev-bijn32nf.us.auth0.com';
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || 'RpknzJposup7f89BZMu44ZwRs9mdkkAo';
export const AUTH0_AUDIENCE  = import.meta.env.VITE_AUTH0_AUDIENCE  || 'https://api.alphalevel.ai';

export const AUTH0_REDIRECT_URI =
  (typeof window !== 'undefined' ? window.location.origin : '') + '/';
